import { render } from "./ShowEmergency.vue?vue&type=template&id=42b2185e&scoped=true"
import script from "./ShowEmergency.vue?vue&type=script&lang=js"
export * from "./ShowEmergency.vue?vue&type=script&lang=js"

import "./ShowEmergency.vue?vue&type=style&index=0&id=42b2185e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b2185e"]])

export default __exports__